<template lang='pug'>
  FaqAdmin(v-if="$store.state.dataUsers.role=='admin'" :title='title')
  FaqUsers(v-else-if="$store.state.dataUsers.role=='general'" :title='title')
</template>

<script>
import FaqAdmin from "../components/FaqAdmin.vue";
import FaqUsers from "../components/FaqUsers.vue";
export default {
  name: "Home",
  components: {
    FaqAdmin,
    FaqUsers
  },
  data: () => ({
    title: "Frequently Asked Questions"
  }),
};
</script>

<style>
.v-main__wrap{
  background: #F3F3F4;
}

.v-application .blue {
  background-color: #01C8F1!important;
  border-color: #01C8F1!important;
}
</style>
